export default __webpack_public_path__ + "static/media/warning.37b2ebe5.webp";